const Url = {
  // baseUrl : "https://api.saawariyabook.com/api"
  // baseUrl : "https://api.saawariyabook.com/api"
  // baseUrl: "https://api.saawariyabook.com/api",
  baseUrl: "http://172.93.223.228:7000/api",
};
export default Url;



// WEBPACK FOOTER //
// ./src/components/configure/configure.js